import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let default_1 = class extends Vue {
  activated() {
    const hash = window.location.search.slice(1);
    if (window.localStorage) {
      window.localStorage.setItem('x-admin-oauth-code', hash);
      window.close();
    }
  }
  render() {
    // Avoid warning for missing template
  }
};
default_1 = __decorate([Component({
  name: 'AuthRedirect'
})], default_1);
export default default_1;